const getBASE_URL = () => {
    if (process.env.REACT_APP_ENV_NAME === 'main') {
        return "https://api.mokpohaewa.com";
    }

    if (process.env.REACT_APP_ENV_NAME === 'sample') {
        return "https://api.shop.l-league.co.kr";
    }

    return "https://mphw.l-league.co.kr";
};

export const BASE_URL = getBASE_URL();